<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:13:36
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
    <div style="padding: 20px 0px 0px 20px;">
  
        <el-form style="display: flex;flex-wrap: wrap;" label-width="120px">

              <el-form-item label="老师姓名:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择老师" v-model="input3" style="width: 100%" clearable filterable>
                      <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="学科组:" style="display: flex;width: 33%;">
                <el-select v-model="input4" style="width:100%;" placeholder="请选择学科组" filterable >
                     <!-- <el-option v-for="item in classTypsArr1" :key="item.categoryIds" :label="item.teacherName"  :value="item.categoryIds"></el-option> -->
                      <el-option v-for="item in classTypsArr1" :key="item.deptId" :label="item.deptName"  :value="item.deptId"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="已满足条件:" style="display: flex;width: 33%;">
                <el-select v-model="input5" style="width:100%;" placeholder="请选择已满足条件" filterable >
                     <el-option v-for="item in classTypsArr11" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="审批状态:" style="display: flex;width: 33%;">
                <el-select v-model="input6" style="width:100%;" placeholder="请选择审批状态" filterable >
                     <el-option v-for="item in subjectArr1" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="提交类型:" style="display: flex;width: 33%;">
                <el-select v-model="input666" style="width:100%;" placeholder="请选择提交类型" filterable >
                     <el-option v-for="item in subjectArr111" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="达标情况:" style="display: flex;width: 33%;">
                <el-select v-model="input6666" style="width:100%;" placeholder="请选择达标情况" filterable >
                     <el-option v-for="item in subjectArr1111" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="创建时间:" style="width: 33%; display: flex;" >
                  <el-date-picker  v-model="dateTime"  type="daterange"   placeholder="选择完成时间"  value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期"   end-placeholder="结束日期" >  </el-date-picker>
              </el-form-item>

           
              <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>
  
        </el-form>
  
  
          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="750">
              <el-table-column prop="teacherName" label="老师姓名" show-overflow-tooltip></el-table-column>
              <el-table-column prop="rankName" label="职级" show-overflow-tooltip></el-table-column>
              <el-table-column prop="deptName" label="学科组" show-overflow-tooltip></el-table-column>
              <el-table-column prop="accomplishTypeName" label="已满足条件" show-overflow-tooltip width="300"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="200"></el-table-column>
              
              <el-table-column prop="commitType" label="提交类型" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.commitType === 1">系统生成</span>
                    <span v-else-if="scope.row.commitType === 2">老师提交</span>
                    <span v-else></span>
                </template>
              </el-table-column>


              <el-table-column prop="standardType" label="达标情况" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.standardType === 1">已达标</span>
                    <span v-else-if="scope.row.standardType === 2">未达标</span>
                    <span v-else></span>
                </template>
              </el-table-column>

              <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.auditStatus === 1">待审批</span>
                    <span v-else-if="scope.row.auditStatus === 2">审批通过</span>
                    <span v-else-if="scope.row.auditStatus === 3">驳回</span>
                    <span v-else>无需审批</span>
                </template>
              </el-table-column>


              <el-table-column label="操作" show-overflow-tooltip>
                <template slot-scope="scope">
                    <!-- <span style="color: #2784e5;" @click="highlightRow(scope.row.id,scope.$index, '详情')"> 详情 </span> -->
                    <!-- <span style="color: #2784e5;margin-left: 20px;" @click="highlightRow(scope.row.id,scope.$index, '编辑')"> 编辑 </span> -->
                     <el-button size="small" type="primary" class="btns"  @click="highlightRow(scope.row.id,scope.$index, '驳回')" :disabled="!(scope.row.auditStatus === 1 && scope.row.commitType === 2)"> 驳回 </el-button>
                     <el-button size="small" type="primary" class="btns"  @click="highlightRow(scope.row.id,scope.$index, '通过')" :disabled="!(scope.row.auditStatus === 1 && scope.row.commitType === 2)"> 通过 </el-button>
                </template>
              </el-table-column>
          </el-table>
  
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>


         <el-dialog title="审批意见" width="60%" style="padding: 0px 50px;" :visible.sync="handleCotShow" :before-close="handleCotShowClers5" :close-on-click-modal="false">
           
            <div style="display: flex;margin-bottom: 30px;">
                <div style="width: 100px;padding-top: 10px;margin-left: 8px;">审批意见：</div>
                <el-input type="textarea" placeholder="请输入面试评价" v-model="CotRadioCntShowtextarea"  :autosize="{ minRows: 6, maxRows: 6 }"  maxlength="300" show-word-limit></el-input>
            </div>
           

            <span slot="footer" class="dialog-footer">
                <div style="text-align: end;">
                    <el-button size="small" type="primary" @click="handleCotShowDialogSubt">确认</el-button>
                    <el-button size="small"  @click="handleCotShowClers5">关闭</el-button>
                </div>
            </span>

        </el-dialog>

  
  
    </div>
  </template>
  
  
  <script>
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { handleStudent, handleTeacher } from "../utils/publicInterface";
  import { getStudentsType } from "@/api/fiveClassApi"
  import { getTeachers } from "@/api/fiveClassApi"
  import { ApiGetStudentList, } from "@/api/apiTask";
  import { getSubject } from "@/api/fiveClassApi"

  export default {
    components:{
  
    },
    data() {
        return{

            input666:'',
            subjectArr111:[
              { id:1, name:'系统生成' }, 
              { id:2, name:'老师提交' },
            ],

            input6666:'',
            subjectArr1111:[
              { id:1, name:'已达标' },
              { id:2, name:'未达标' },
            ],


            handleCotShow:false,  //面试意见弹框显示与否

            CotRadioCntShowtextarea:'',  //面试意见评价内容

            cascaderprops: { value: 'id', label: 'salaryPlanName', children: 'teacherRankList' },
            input10:[],
            dateTime:[],
  
            options:[],
            options1:[{id:1,realname:'初级老师'},{id:2,realname:'中级老师'},{id:3,realname:'高级老师'},{id:4,realname:'特级老师'}],
            options2:[{id:1,realname:'待审批'},{id:2,realname:'审批中'},{id:3,realname:'驳回'},{id:4,realname:'已完成'}],
  
            input1:'',
            input2:'',
            input3:'',
            dataList:[],
  
            pageNum: 1,
            pageSize: 10,
            total: 0,
  
            form:{
                input1:'',
                input2:true,
                input3:'',
            },
  
            titleDialogShowvisible:false,
            titleDialogShowvisible1:false,
            textareainput:'',
  
            fromlabel:'',
            placeholderfrom:'',
            titleDialogShowvisibletitle1:'',
            
            optionsListt:[],
            getStudentsArr_s:[],
            subjectArr:[],
            subjectArr1:[
              { id:1, categoryName:'待审批' },
              { id:2, categoryName:'审批通过' },
              { id:3, categoryName:'驳回' },
              { id:0, categoryName:'无需审批' },
            ],

            input4:'',
            input5:'',
            input6:'',

            classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
            classTypsArr1:[],
            classTypsArr11:[
              {
                id:1,
                name:'半月测成绩达到优异：六个月内连续3次或者累计5次半月测成绩达到优异'
              },
              {
                id:2,
                name:'非寒暑假月份的当月第一周稳定上课（满5节课）学员达到10名；寒暑假月份的学员需满足转季后的第一周稳定上课（满5节课）学员数达到10名'
              },
              {
                id:3,
                name:'任意连续3个月内的所有学员首次课成功率达到80%'
              },
              {
                id:4,
                name:'阶段时间内连续10个学员满5 节课的续报率达到 80%'
              },
              {
                id:5,
                name:' 6 个月内课节数累计满250节'
              },
              {
                id:6,
                name:'6个月内满20节课的学员数量累计达到5名'
              },
              {
                id:7,
                name:'6个月内扩科数量累计达到5个；（与奖励可同时享受）'
              },
              {
                id:8,
                name:'内推成功且入职三个月员工数达到2名：（与奖励可同时享受）'
              },
              {
                id:9,
                name:'参加工作坊时长累计达到20天'
              },
              {
                id:10,
                name:'一年内任意一次转季学员留存率≥80%（学员数量需≥5名）'
              },
            ],

            input66:[],
            classTypsArr1111:[],
            
            objID:'',
            isType:'',

        }
    },
  
    mounted(){
      // this.classTypsArr1 = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
      getTeachers().then(res => {  this.options = res.data })
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.optionsListt = res.data.data})
      ApiGetStudentList().then((res) => {  let { data } = res; this.getStudentsArr_s = data;  });
      // axios.post(`${apiBaseUrl}/teacherRank/findList`, {},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
      //   if(res.data.code == 200) {
      //       this.classTypsArr11 = res.data.data
      //   }else {
      //       this.$message.error(res.data.message);
      //       this.classTypsArr11 =  []
      //     }
      // }).catch(err => {
      //       this.classTypsArr11 =  []
      // });
      // axios.get(`${ apiBaseUrl }/organizational/getDeptInfoSon`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.classTypsArr1 = res.data.data})

      // getSubject().then(res => {   this.subjectArr = res.data   })
      axios.get(`${ apiBaseUrl }/schedule/teacherCategorylist`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
        this.subjectArr = res.data.data
      })

      axios.get(`${ apiBaseUrl }/organizational/getDeptInfoSon`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
        this.classTypsArr1 = res.data.data
      })


      this.getApiList()
    },
  
  
    methods:{

        handleCotShowClers5(){
          this.handleCotShow = false
          this.CotRadioCntShowtextarea = ''
          this.isType = ''
          this.objID = ''
        },


        handleCotShowDialogSubt(){
            let data = {
                auditCause: this.CotRadioCntShowtextarea,
                auditStatus: this.isType,
                id: this.objID,
            }
            axios.post(`${apiBaseUrl}/teacherUpgrade/audit`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                  if(res.data.code === 200){
                    this.$message({ message: res.data.message , type: "success" })
                    this.getApiList()
                    this.handleCotShowClers5()
                  }else{
                    this.$message({ message: res.data.message , type: "error" })
                  }
            }).catch((err)=>{
                this.$message({ message: err , type: "error" })
            })
        },

        highlightRow (id,index,name) {
            // this.$router.push({
            //     name: '在职教师详情', 
            //     params: { id, } 
            // })

            if(name === '详情'){

            }


            if(name === '编辑'){
              
            }


            if(name === '驳回'){
              this.objID = id
              this.isType = 3
              this.handleCotShow = true
            }


            if(name === '通过'){
              this.objID = id
              this.isType = 2
              this.handleCotShow = true
            }


        },


        getApiList(){
            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                createDateStart: this.dateTime.length > 0 ? this.dateTime[0] + ' 00:00:00': '',
                createDateEnd: this.dateTime.length > 0 ? this.dateTime[1] + ' 23:59:59': '',
                accomplishType: this.input5,
                auditStatus: this.input6,
                teacherId: this.input3,
                deptId: this.input4,
                commitType: this.input666,
                standardType: this.input6666,
            }
            axios.post(`${apiBaseUrl}/teacherUpgrade/findPage`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
  
                  if(res.data.code === 200){
  
                    let data = res.data.data
                    this.dataList = data.records
                    // this.pageNum = data.current ? data.pageIndex : 0
                    // this.pageSize = data.size ? data.size : 10
                    this.total = data.total
  
                    this.$message({ message: res.data.message , type: "success" })
                  }else{
                    this.dataList = []
                    this.total = 0
                    this.$message({ message: res.data.message , type: "error" })
                  }
            }).catch((err)=>{
                this.dataList= []
                this.pageSize = 10
                this.pageNum = 1
                this.total = 0
                this.$message({ message: err , type: "error" })
            })
        },
  
  
        titlerejectDialogShowClr(){
          this.titleDialogShowvisible = false
        },
  
        titlerejectDialogShowClr1(){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        },
  
        titlerejectDialogShowSubt1(){
          if(this.textareainput){
            this.textareainput = ''
            this.titleDialogShowvisible1 = false
          }else{
            this.$message({ message: '请填写备注~' , type: "warning" })
          }
        },
  
        searchBtns(){
          this.pageNum = 1
          this.pageSize = 10
          this.getApiList()
        },

        exportBtns(){
            let data = {
                pageNo: this.pageNum,
                pageSize: this.pageSize,
                formalTrainingDateStart: this.dateTime.length > 0 ? this.dateTime[0] : '',
                formalTrainingDateEnd: this.dateTime.length > 0 ? this.dateTime[1] : '',
                realname: this.input3,
                deptId: this.input6,
                teach: this.input66.length > 0 ? JSON.stringify(this.input66) : '',
            }
            axios.post(`${apiBaseUrl}/teacher/exportJobTeacher`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "在职教师.xlsx"; 
                    downloadLink.click();
                    this.$message({ message: res.data.message , type: "success" })
                }
                else{
                    this.$message({ message: res.data.message , type: "error" })
                }
            })
        },
  
        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''
            this.input66 = []
            this.input10 = []
            this.dateTime = []
            this.input666 = ''
            this.input6666 = ''
            this.pageNum = 1
            this.pageSize = 10
            this.getApiList()
        },
  
        handleSizeChange(e){
            this.pageSize = e
            this.getApiList()
        },
  
        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },
  
        handleClickView(type,itme){
          console.log(itme)
          if(type === 2){
            this.titleDialogShowvisible = true
          }
          if(type === 1){
            this.titleDialogShowvisible = true
          }
  
        },
  
        titlerejectDialogShowClrB(){
          this.titleDialogShowvisibletitle1 = '审批意见'
          this.fromlabel = '备注：'
          this.placeholderfrom = '请输入意见'
          this.titleDialogShowvisible1 = true
        },
        titlerejectDialogShowClrS(){
          this.titleDialogShowvisibletitle1 = '驳回原因'
          this.fromlabel = '驳回原因：'
          this.placeholderfrom = '请输入驳回原因'
          this.titleDialogShowvisible1 = true
        },
    }
  
  }
  </script>
  
  
  <style scoped lang="less">
  
    .no-click {
        pointer-events: none;
    }
  
    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
        height: 27px;
        line-height: 0px;
    }

    .btns1{
        background-color: #babdbf;
        border-color: #303132;
        color: #fff;
        height: 27px;
        line-height: 0px;
    }
  
    /deep/ .el-form-item__content{
        margin-left: 0 !important;
    }
  
  </style>
  


// WEBPACK FOOTER //
// src/TeacherUpgrade/TeacherUpgrade.vue